import '@web/shared-digital-library/icons/svg-originals/facebook.svg';
import '@web/shared-digital-library/icons/svg-originals/instagram.svg';
import '@web/shared-digital-library/icons/svg-originals/tiktok.svg';
import '@web/shared-digital-library/icons/svg-originals/twitter.svg';
import '@web/shared-digital-library/icons/svg-originals/pinterest.svg';
import '@web/shared-digital-library/icons/svg-originals/youtube.svg';
var MdmLink = () => import('~/components/atoms/MdmLink.vue');
export default {
  name: 'Socials',
  components: {
    MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};